import { Box, Typography, useTheme } from '@mui/material';
import dayjs from 'dayjs';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ActiveOrder } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/order-assortment.type';
import { BluBox } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/utils/styled-components';

type Props = {
  order?: ActiveOrder;
  openSlot?: boolean; // this is bad. we should probably separate them out
};

const PAGE_NAME_ID = 'orderFeed.ofdMySupplyPlan.cards.orderStatusInfo';

const OrderCardInfo: React.FC<Props> = ({ order }) => {

  if (!order) return;

  return (
    <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} gap={4}>
      {order.orderComment.length > 0 && (
        <BluBox flex={"0 1 50%"}>
          <Typography variant="h5" fontWeight={'800'}>
            <FormattedMessage id={`${PAGE_NAME_ID}.confirmed.orderCommentTitle`} />
          </Typography>
          <Typography variant="body2" fontSize={14} whiteSpace={"normal"}>
            {order.orderComment}
          </Typography>
        </BluBox>
      )}

      <BluBox flex={"0 0 50%"} >
        <Typography variant="h5" fontWeight={'800'}>
          <FormattedMessage id={`${PAGE_NAME_ID}.confirmed.changesTitle`} />
        </Typography>
        <Typography variant="body2" fontSize={14}>
          <FormattedMessage
            id={`${PAGE_NAME_ID}.confirmed.changesContent`}
            values={{
              date: <b>{dayjs(order.lastPossibleEditDate).format('D MMMM')}</b>,
              daysLeft: order.remainingEditDays,
              br: <br />,
            }}
          />
        </Typography>
      </BluBox>
    </Box>
  );
};

export default React.memo(OrderCardInfo);
